export const getSanitisedCardName = (cardName: string) => {
    return cardName
        .trim() // remove white-space either side
        .toLowerCase() // all lower-case
        .replace(/\s/g, '-') // convert all white-space to hyphens
        .replace(/[^a-z0-9-]/g, '') // strip all but lowercase alphanumeric and hyphen
}
